import moment from 'moment';
import format from 'string-template';
import { DateFormat } from '../../../../../../utils/date';

import texts from './texts.json';

const getColumns = ({
  equipmentRenderCell,
  actionsRenderCell,
  isAdmin,
  showTrackType,
}) => {
  const columns = [
    {
      field: 'name',
      quickSearch: true,
      headerName: texts.columns.trackName,
      flex: 1,
    },
    ...(showTrackType ? [{
      field: 'type',
      headerName: texts.columns.trackType,
      flex: 1,
      valueGetter: ({ row }) => texts.trackType[row.type] || texts.trackType.STANDARD,
    }] : []),
    {
      field: 'createdAt',
      headerName: texts.columns.createdOn,
      flex: 1,
      type: 'datetime',
      valueGetter: ({ row }) => new Date(row.createdAt),
      renderCell: ({ row }) => (
        moment(row.createdAt).format(DateFormat.DATE_FORMAT_COMMA)
      ),
    },
    {
      field: 'difficulty',
      headerName: texts.columns.difficulty,
      flex: 1,
      valueGetter: ({ row }) => (
        row.difficulty || texts.emptyCell
      ),
    },
    {
      field: 'programCount',
      headerName: texts.columns.programCount,
      flex: 1,
      valueGetter: ({ row }) => (
        format(texts.programCount, { count: row.programs?.length ?? 0 })
      ),
    },
    {
      field: 'equipment',
      headerName: texts.columns.equipment,
      sortable: false,
      flex: 1,
      renderCell: equipmentRenderCell,
    },
    {
      field: 'actions',
      headerName: texts.columns.actions,
      sortable: false,
      filterable: false,
      width: 300,
      renderCell: actionsRenderCell,
    },
  ];

  if (isAdmin) {
    columns.splice(1, 0, {
      field: 'trackId',
      headerName: texts.columns.trackId,
      flex: 1,
      valueGetter: ({ row }) => row.id || texts.emptyCell,
      hide: true,
    });
  }

  return columns;
};

export default getColumns;
